const getImageUrl = image => {
  if (!image) return ''
  if (typeof image === 'string') return image
  if (typeof image === 'object') {
    return image.url || image.src || image.path || image.original || ''
  }
  return ''
}

export default getImageUrl
